import { Button } from "@thetreep/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useChatStore } from "@stores/chatStore";

export function CookiePrompt() {
  const { t } = useTranslation();
  const setCookiesAccepted = useChatStore((s) => s.setCookiesAccepted);
  const [showPrompt, setShowPrompt] = useState(
    () => !localStorage.getItem("cookie-accepted"),
  );

  const handleAccept = () => {
    localStorage.setItem("cookie-accepted", "true");
    setCookiesAccepted(true);
    setShowPrompt(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookie-accepted", "false");
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-2 left-2 right-2 z-[3000]">
      <div className="bg-white rounded-lg p-6 shadow-md border border-neutral-400 w-full mx-auto">
        <div className="flex flex-col justify-between gap-4">
          <h2 className="text-text-strong text-xl font-jakarta font-bold">
            {t("cookies.title")}
          </h2>
          <p className="text-text-strong font-jakarta">{t("cookies.body")}</p>
          <div className="flex gap-4 items-end justify-end w-full">
            <Button kind="outline" size="compact" onClick={handleReject}>
              Refuser
            </Button>
            <Button kind="primary" size="compact" onClick={handleAccept}>
              Accepter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
